import React, { FC, ReactNode, useMemo, useState } from 'react'
import { Avatar, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from '@mui/material'
import useConfig from '@plug-core/hooks/useConfig'
import { useTranslation } from 'react-i18next'
import { HiQuestionMarkCircle } from 'react-icons/hi2'
import { useSns } from '@plug-core/state'
import Carousel from '@components/Carousel'
import { TokenGridItem } from '@components/TokenGridItem/TokenGridItem'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import Touchable from '@components/Touchable'

interface Banner {
  title: string
  description: string
  visual: ReactNode
}

const TokensTab: FC = () => {
  const { tokens, top5Tokens } = useConfig()
  const { t } = useTranslation()

  const { sns } = useSns()

  const navigate = useNavigate()

  return (
    <Stack spacing={2}>
      <Typography>{t('discover.tabs.home.snsTokens')}</Typography>
      <Carousel itemSize={150} spacingPx={20}>
        {sns.map((sns) => (
          <TokenGridItem
            sns={sns}
            onClick={() => {
              const token = tokens.find((t) => t.address === sns.ledgerCanisterId)

              if (token) {
                navigate(ROUTES.TOKEN_DETAILS(token.id))
              }
            }}
            key={sns.symbol}
          />
        ))}
      </Carousel>

      <Stack direction="row" justifyContent="space-between">
        <Typography>{t('discover.tabs.home.top5Tokens')}</Typography>
        <Typography>{t('discover.tabs.home.volume')}</Typography>
      </Stack>

      {top5Tokens.map((token, index) => {
        const foundToken = tokens.find((t) => t.symbol == token.symbol)

        return (
          <Touchable
            onClick={() => foundToken && navigate(ROUTES.TOKEN_DETAILS(foundToken.id))}
            key={token.symbol}
          >
            <ListItem>
              <ListItemAvatar>
                <Stack direction="row" alignItems="center" spacing={1.5} mr={2}>
                  <Typography>{index + 1}</Typography>
                  <Avatar src={foundToken?.logo}>
                    {!foundToken?.logo && <HiQuestionMarkCircle />}
                  </Avatar>
                </Stack>
              </ListItemAvatar>
              <ListItemText primary={foundToken?.name} secondary={token.symbol} />
              <ListItemText
                primary={`${(token.volume / 1000).toFixed(3)}K`}
                secondary="ICP"
                primaryTypographyProps={{ textAlign: 'right' }}
                secondaryTypographyProps={{ textAlign: 'right' }}
              />
            </ListItem>
          </Touchable>
        )
      })}
    </Stack>
  )
}

export default TokensTab
